// Toast helper file
// Inspired by https://github.com/primefaces/primevue/blob/master/packages/primevue/src/toastservice/ToastService.js#L10
import ToastEventBus from 'primevue/toasteventbus';

const toastSettings = {
	life: 5000
}

// This is needed to let existing toasts to be cleaned up if stacking is disabled
const showDelay = 200

let timeout;

function toastGeneric(severity, summary){
	// Remove all toasts and clear existing timeouts if any
	ToastEventBus.emit('remove-all-groups')
	clearTimeout(timeout)
	
	// Show new toast
	timeout = setTimeout(() => ToastEventBus.emit('add', {...toastSettings, ...{ severity, summary }}), showDelay)
}

export const toastSuccess = text => toastGeneric('success', text)
export const toastInfo = text => toastGeneric('info', text)
export const toastError = text => toastGeneric('error', text)
export const toastWarning = text => toastGeneric('warn', text)